import React from "react";
import ArticleSection from "../components/Home/ArticleSection";
import Banner from "../components/Home/Banner";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LandingPage from "../components/Home/LandingPage";
import Faqs from "../components/Home/Faqs";

const Home = () => {
  let navigate = useNavigate();

const getUser = async () => {
  try {
    const url = `${process.env.REACT_APP_BASE_URL}/auth/login/success`;
    const { data } = await axios.get(url, { withCredentials: true });
    
    // console.log(data.user.existingUser);
    localStorage.setItem("userId", data.user.existingUser._id);
    localStorage.setItem("userINfo", JSON.stringify(data.user.existingUser));
    localStorage.setItem("TOKEN", data.user.existingUser.token);
     navigate("/");
  } catch (err) {
    console.log(err);
  }
};

useEffect(() => {
  getUser();
}, []);

  return (
    <div>
      <Banner />
      <LandingPage />
      <Faqs/>
      {/* <ArticleSection /> */}
    </div>
  );
};

export default Home;
